import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/cases/listpage/telecommunications/Template'
import { caseStudyItems } from 'components/cases/Case/CaseStudyItem'

const categoryTitle = 'メーカー/製造/建設'

const Manufacturing: React.FC<{ pageId: number }> = ({ pageId }) => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])

  return (
    <>
      <CustomHead
        keyword={'事例 実績 メーカー 製造業 建設業'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={`https://aitria.co.jp/cases/manufacturing/page/${pageId}/`}
        title={`${categoryTitle} | 事例 | ページ ${pageId} | Aitria（アイトリア）`}
        description="メーカー/製造/建設のケーススタディを紹介します｜Aitria（アイトリア）はビジネス・デザイン・テクノロジーの力を駆使して、顧客のミッションをあらゆる角度から伴走支援するデジタルイノベーションパートナー事業を展開しています。"
      />
      <Template pageId={pageId} />
    </>
  )
}

export async function getStaticPaths() {
  const filteredItems = caseStudyItems.filter((item) => item.tags.some((tag) => tag.tag === categoryTitle))
  const totalItems = filteredItems.length
  const pageSize = 10
  const totalPages = Math.ceil(totalItems / pageSize)
  const paths = Array.from({ length: totalPages }, (_, i) => ({
    params: { id: (i + 1).toString() },
  }))

  return {
    paths,
    fallback: false,
  }
}

export async function getStaticProps({ params }) {
  return {
    props: {
      pageId: Number(params.id),
    },
  }
}

export default Manufacturing
